import { useMemo } from "react";
import { ViewModelContainer } from "./viewmodel";
export function useViewModel(viewModelClass, ...args) {
    return useMemo(() => {
        return ViewModelContainer.getInstance().getViewModel(viewModelClass, args);
    }, []);
}
